import React, { useState } from 'react'
import { Color } from '../../assets/color';
import DownloadIcon from '@mui/icons-material/Download';
import DataTable from 'react-data-table-component';
import { ConvertAOBKeysToUpperCase, DeepSearchSpace, ExcelDownload } from '../../utils/common-function';

const DatatableWithSearch = ({ data = [], placeholder = 'Search your data...', searchkey = '', columns, pagination = false, inputFieldVisible = true, showDownloadButton = true, title = '' }) => {
    const [searchText, setSearchText] = useState(searchkey);

    const handleSearch = (event) => setSearchText(event.target.value);

    const filteredData = DeepSearchSpace(data, searchText);

    const DataTableCustomStyles = {
        cells: {
            style: {
                textAlign: "center", color: "rgba(0, 0, 0, 0.6)", whiteSpace: "nowrap", fontSize: "14px", width: "150px",
            },
        },
        rows: {
            style: {
                minHeight: '60px', backgroundColor: Color.white
            },
        },
        headRow: {
            style: {
                whiteSpace: 'nowrap', fontSize: "16px", fontWeight: "500", color: Color.white, background: "linear-gradient(to right,  #6653E8, #9544EB)", borderRadius: '10px'
            }
        },
        // table: {
        //     style: {
        //         height: '400px', // Adjust based on your needs (or use `maxHeight`)
        //         overflowY: 'auto', // Allow scrolling inside the table body
        //     },
        // },
    };

    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between", gap: '20px', marginBottom: "20px", backgroundColor: "#fff" }}>
                {inputFieldVisible &&
                    <input
                        style={{
                            padding: '12px 20px',
                            borderRadius: '100px',
                            border: '3px solid #ccc',
                            width: '100%',
                            fontSize: '15px',
                            outline: 'none',
                            boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)',
                            transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                        }}
                        type='search'
                        value={searchText}
                        onChange={handleSearch}
                        placeholder={placeholder}
                        onFocus={(e) => e.target.style.border = `3px solid ${Color?.primary}`}
                        onBlur={(e) => e.target.style.border = '3px solid #ccc'}
                        onMouseEnter={(e) => e.target.style.border = `3px solid ${Color?.primary}`}
                        onMouseLeave={(e) => {
                            if (document.activeElement !== e.target) {
                                e.target.style.border = '3px solid #ccc';
                            }
                        }}
                    />
                }

                {showDownloadButton && filteredData && <div onClick={() => ExcelDownload(title, filteredData)} style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: '14.5px', fontWeight: '500', padding: '10px 20px 9px 20px', borderRadius: '100px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: "#FFF", cursor: 'pointer' }}>
                    <DownloadIcon />
                    <p style={{ textWrap: 'nowrap' }}> Download Data</p>
                </div>}
            </div >

            <DataTable
                columns={columns}
                data={filteredData?.sort((a, b) => new Date(b.created) - new Date(a.created))}
                pagination={pagination}
                customStyles={DataTableCustomStyles}
                paginationPerPage={5}
                paginationRowsPerPageOptions={[5, 10, 15, 20]}
                paginationComponentOptions={{ rowsPerPageText: 'Rows Per Page :' }}
                fixedHeader
            />
        </>
    )
}

export default DatatableWithSearch;